import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import auth from '@/services/authentication';
import { submissionState, updateSubmissionState } from '@/observables/submissions';
import Home from './views/Home.vue';
import store from './store';
// import { SIGNINSIGNUPPOLICYNAME } from '@/services/b2cConfig.js';
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        // {
        //   path: '/print',
        //   name: 'print',
        //   component: () => import(/* webpackChunkName: "Print" */ '@/components/print.vue')
        // },
        {
            path: '/my-pension/pension-tool/:illustrationIndex',
            name: 'pension-tool',
            props: true,
            component: () => import(/* webpackChunkName: "PensionTool" */ '@/views/modeller/Wrapper.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/my-pension/my-data',
            name: 'my-data',
            component: () => import(/* webpackChunkName: "MyData" */ '@/views/MyData.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/pension-news',
            name: 'pension-news',
            component: () => import(/* webpackChunkName: "PensionNews" */ '@/views/PensionNews.vue'),
        },
        {
            path: '/pension-news/:newsId',
            name: 'pension-news-item',
            component: () => import(/* webpackChunkName: "NewsPost" */ '@/views/NewsPost.vue'),
        },
        {
            path: '/my-pension/edit-my-details',
            name: 'edit-pension-data',
            component: () => import(/* webpackChunkName: "EditPensionData" */ '@/views/EditPensionData.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/my-pension/activity',
            name: 'activity',
            component: () => import(/* webpackChunkName: "Activity" */ '@/views/Activity.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/my-pension/additional-information',
            name: 'additional-info',
            component: () => import(/* webpackChunkName: "AdditionalInfo" */ '@/views/AdditionalInfo.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/my-pension/payslips',
            name: 'payslips',
            component: () => import(/* webpackChunkName: "Payslips" */ '@/views/Payslips.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/my-pension/p60',
            name: 'payslips-p60',
            component: () => import(/* webpackChunkName: "P60" */ '@/views/P60Documents.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/web-forms',
            name: 'web-forms-home',
            component: () => import(/* webpackChunkName: "WebFormsHome" */ '@/views/portal/WebFormsHome.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/web-forms/:formId',
            name: 'editWebForm',
            component: () => import(/* webpackChunkName: "editWebForm" */ '@/views/portal/editWebForm.vue'),
            meta: {
                saveProgress: true,
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/scheme-information',
            redirect: '/information',
        },
        {
            path: '/scheme-information/:schemeId',
            redirect: '/information/:schemeId',
        },
        {
            path: '/information',
            name: 'information',
            component: () => import(/* webpackChunkName: "SchemeInfo" */ '@/views/SchemeInformation.vue'),
        },
        {
            path: '/information/:schemeId',
            name: 'information-item',
            component: () => import(/* webpackChunkName: "SchemeInfoPost" */ '@/views/SchemeInfoPost.vue'),
        },
        {
            path: '/links',
            name: 'links',
            component: () => import(/* webpackChunkName: "Links" */ '@/views/Links.vue'),
        },
        {
            path: '/contact',
            name: 'contact',
            component: () => import(/* webpackChunkName: "Contact" */ '@/views/Contact.vue'),
        },
        {
            path: '/submissions',
            name: 'submissionsHome',
            component: () => import(/* webpackChunkName: "SubmissionsHome" */ '@/views/submissions/SubmissionHome.vue'),
            meta: {
                hideInnerNav: true,
                hideFooter: true,
                form: true,
            },
        },
        {
            path: '/submissions/:submissionId',
            name: 'submission',
            component: () => import(/* webpackChunkName: "Submission" */ '@/views/submissions/showSubmission.vue'),
            meta: {
                hideInnerNav: true,
                hideFooter: true,
                form: true,
                requiresSubAuth: true,
            },
        },
        {
            path: '/submissions/:submissionId/form/:formId',
            name: 'editForm',
            component: () => import(/* webpackChunkName: "editForm" */ '@/views/submissions/editForm.vue'),
            meta: {
                hideInnerNav: true,
                hideFooter: true,
                form: true,
                saveProgress: true,
                requiresSubAuth: true,
            },
        },
        {
            path: '/submissions/legal/terms',
            name: 'submissionTerms',
            component: () => import(/* webpackChunkName: "editForm" */ '@/views/submissions/submissionTerms.vue'),
            meta: {
                hideInnerNav: true,
                hideFooter: true,
                form: true,
            },
        },
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "Login" */ '@/views/mockLogin/login.vue'),
            meta: {
                hideNav: true,
                hideFooter: true,
            },
        },
        {
            path: '/register',
            name: 'register',
            component: () => import(/* webpackChunkName: "Register" */ '@/views/Register.vue'),
            meta: {
                requiresAuth: true,
                hideInnerNav: false,
                onlyShowContact: true,
            },
        },
        {
            path: '/logout',
            name: 'logout',
            component: () => import(/* webpackChunkName: "logout" */ '@/views/auth/logout.vue'),
            meta: {},
        },
        {
            path: '/deregister',
            name: 'deregister',
            component: () => import(/* webpackChunkName: "deregister" */ '@/views/auth/deregister.vue'),
            meta: {},
        },
        {
            path: '/auth/check',
            name: 'auth-check',
            component: () => import(/* webpackChunkName: "AuthCheck" */ '@/views/auth/check.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/auth/lock',
            name: 'auth-lock',
            component: () => import(/* webpackChunkName: "AuthCheck" */ '@/views/auth/lock.vue'),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: '/auth/update-email-address',
            name: 'update-email-address',
            component: () => import(/* webpackChunkName: "death-notification" */ '@/views/auth/UpdateEmailAddress.vue'),
            meta: {
                requiresAuth: true,
            },
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import(/* webpackChunkName: "AuthCheck" */ '@/views/Admin.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,
            },
        },
        {
            path: '/frequently-asked-questions',
            name: 'faqs',
            component: () => import(/* webpackChunkName: "faqs" */ '@/views/Faqs.vue'),
        },
        {
            path: '/terms',
            name: 'terms',
            component: () => import(/* webpackChunkName: "terms" */ '@/views/Terms.vue'),
        },
        {
            path: '/privacy-policy',
            name: 'privacy-policy',
            component: () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy.vue'),
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: () => import(/* webpackChunkName: "feedback" */ '@/views/Feedback.vue'),
        },
        {
            path: '/notify-us-of-a-death',
            name: 'death-notification',
            component: () => import(/* webpackChunkName: "death-notification" */ '@/views/forms/DeathSubmission.vue'),
        },
        {
            path: '/power-of-attorney',
            name: 'power-of-attorney',
            component: () => import(/* webpackChunkName: "power-of-attorney" */ '@/views/forms/PowerOfAttorney.vue'),
        },
        {
            path: '/forms/:submissionId',
            name: 'WebFormsHome',
            component: () => import(/* webpackChunkName: "WebFormsHome" */ '@/views/submissions/showSubmission.vue'),
            meta: {
                requiresAuth: true,
                requireRegistered: true,

            },
        },
        {
            path: '/500',
            name: 'error',
            component: () => import(/* webpackChunkName: "NotFound" */ '@/views/500.vue'),
        },
        {
            path: '/*',
            name: 'not-found',
            component: () => import(/* webpackChunkName: "NotFound" */ '@/views/404.vue'),
        },
    ],
});
async function userRegistered () {
    const isRegistered = store.getters['auth/getIsRegistered'];
    if (isRegistered === null || isRegistered === false) {
        return store.dispatch('auth/checkIfRegistered', true).then(result => result.isRegistered);
    }
    return new Promise(resolve => resolve(isRegistered));
}

async function userLoggedIn () {
    // check to see if we have the auth details in STATE
    const isLoggedIn = true;
    if (!store.getters['auth/getAuthState']) {
        return store.dispatch('auth/checkIfLoggedIn').then(result => result);
    }
    return new Promise(resolve => resolve(isLoggedIn));
}


function isRegistrationAndLoginDisabled (to, disableRegistrationAndLogin) {
    if (to.meta.requiresAuth && !!disableRegistrationAndLogin) {
        // block access to the page if registration and login is disabled
        return true;
    }
    return false;
}


router.beforeEach(async (to, from, next) => {
    // #region forms routing

    const formSites = ['forms.lcp.uk.com', 'forms.lcptest.co.uk', 'formsqa.lcptest.co.uk'];
    if (formSites.includes(window.location.hostname) || window.location.port === '8893') {
        if (!to.meta.form) {
            next('/submissions');
        }
        if (to.meta.requiresSubAuth) {
            if (!submissionState.auth.loggedIn) {
                if (to.params.submissionId) {
                    updateSubmissionState.updateSubmissionId(to.params.submissionId);
                    updateSubmissionState.updateSubmissionId(to.params.submissionId);
                }
                store.commit('auth/setSessionExpired', to.query.sessionExpired);
                next('/submissions');
            }
        }
    }
    // #endregion

    // let needToRegister = false;
    store.commit('toggleMenuMobile', false);

    // #region check passoword reset
    if (await store.dispatch('auth/checkIfPasswordResetRequested').then(result => result)) {
        // next('#');
        auth.resetPassword();
        return;
    }
    // #endregion

    // #region checking for impersonate users
    if (to.query.Impersonate) {
        if (axios.defaults.headers.get.ImpersonateId !== to.query.Impersonate) {
            store.dispatch('clearDashboardData');
        }
        axios.defaults.headers.get.ImpersonateId = to.query.Impersonate;
        axios.defaults.headers.post.ImpersonateId = to.query.Impersonate;
        axios.defaults.headers.put.ImpersonateId = to.query.Impersonate;
    }

    if (to.query.impersonate) {
        if (axios.defaults.headers.get.ImpersonateId !== to.query.impersonate) {
            store.dispatch('clearDashboardData');
        }
        axios.defaults.headers.get.ImpersonateId = to.query.impersonate;
        axios.defaults.headers.post.ImpersonateId = to.query.impersonate;
        axios.defaults.headers.put.ImpersonateId = to.query.impersonate;
    }
    // #endregion

    // #region checking for #error in url

    if (to.redirectedFrom != null && to.redirectedFrom.includes('#error')) {
        return;
    }
    // #endregion
    if (to.meta.requiresAuth) {
        if (isRegistrationAndLoginDisabled(to, store.getters['clientConfig/clientConfig'].disableRegistrationAndLogin)) {
            next('/');
            return;
        }

        await userLoggedIn().then((result) => {
            if (!result) {
                auth.init();
                store.commit('analytics/setLoggingIn');
                auth.signInSignUp();
            } else if (to.meta.requireRegistered) {
                userRegistered().then((registered) => {
                    if (!registered) {
                        next('/register');
                    } else {
                        next();
                    }
                });
            } else {
                next();
            }
        });
    } else {
        next();
    }

    // if (needToRegister) {
    //     next('/register');
    // } else {
    //     next();
    // }
});

export default router;
